<template>
    <div class="home">
        <van-image fit="contain" :src="require('@img/banner_home@2x.jpg')" width="100%"></van-image>
        <van-cell-group>
            <van-cell
                v-for="(item, index) in accountList" is-link
                :key="index"
                :title="item.title"
                :icon="require(`@img/${item.icon}`)"
                @click="routingTo(item.link)"
            />
        </van-cell-group>
    </div>
</template>

<script>
import {Image, Grid, GridItem, CellGroup, Cell,} from 'vant';
import 'vant/es/image/style';
import 'vant/es/grid/style';
import 'vant/es/grid-item/style';
import 'vant/lib/cell/style';
import 'vant/lib/cell-group/style';
import store from '@center/store'

export default {
    name: "hmdefalut",
    components: {
        vanImage: Image,
        vanGrid: Grid,
        vanGridItem: GridItem,
        vanCellGroup: CellGroup,
        vanCell: Cell,
    },
    mounted() {
    },
    data() {
        return {
            accountList: [
                {
                    title: '公积金基本信息查询',
                    link: 'accountInfo',
                    icon: 'icon_gjjjbxxcx@2x.png'
                },
                {
                    title: '公积金明细查询',
                    link: 'accountDetail',
                    icon: 'icon_gjjmxcx@2x.png'
                },
                {
                    title: '贷款基本信息查询',
                    link: 'loanInfo',
                    icon: 'icon_dkjbxxcx@2x.png'
                },
                {
                    title: '还款明细查询',
                    link: 'repaymentDetail',
                    icon: 'icon_hkmxcx@2x.png'
                },
            ]
        };
    },
    created: function(){

    },
    methods: {
        routingTo(target){
            let self = this;
            self.$router.push({
                path: '/' + target,
                query: {

                }
            });
        }
    }
};
</script>
<style lang="stylus">
body
    background #e5e5e5
</style>
<style lang="stylus" scoped>
.van-cell
    align-items center
</style>